module.exports = __webpack_public_path__ + "img/logo.37e319bb.png";